// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { Form, Text, TextArea } from 'informed';
import moment from 'moment';

import {
  addReport,
  updateReport,
} from '../../../actions/counselingReportActions';

import { PrimaryText, Label } from '../../Typography.jsx';
import ContentBox from '../../ContentBox.jsx';
import Multiselect from '../../Multiselect.jsx';
import { Button, PrimaryButton } from '../../Buttons.jsx';
import DatetimeText from '../../DatetimeText.jsx';

import styles from '../../../styles/patientPages/progressNote/progressNote.scss';

const topicOptions = [
  'Conflict Resolution',
  'Marriage',
  'Family',
  'Self-esteem',
  'Depression',
  'Life Plans',
  'Spiritual Issues',
  'Sexual Abuse',
  'Substance Abuse',
  'Work Issues',
  'Grief or Loss',
  'Relationships',
  'Children',
];

type Props = {
  reportId: ?String,
  counselingReports: Object[],
  /*
  (report: Object) => {}
  */
  addReport: Function,
 /*
   (reportId: string, report: Object) => {}
 */
  updateReport: Function,
  activePatientId: string,
  activeAccount: Object,
  closePage: Function,
}

class EditReportComponent extends React.Component<Props> {
  formApi: {
    getState: Function,
    reset: Function,
  }

  setFormApi = (formApi: Object) => {
    this.formApi = formApi;
  }

  // Misc functions
  /* eslint-disable no-param-reassign */
  transformData(formValues: Object) {
    formValues.date = moment(formValues.date, 'DD-MM-YYYY, HH:mm').toISOString();
    // add active account for edit history
    const { activeAccount } = this.props;
    formValues.editor = `${activeAccount.name}, ${activeAccount.credential}`;
    formValues.editDate = moment().toISOString();
  }

  handleSave = () => {
    const formData = this.formApi.getState();
    if (formData.invalid) {
      return;
    }
    if (!Object.keys(formData.touched).length) {
      this.props.closePage();
      return;
    }
    this.transformData(formData.values);
    if (!this.props.reportId) {
      this.props.addReport(this.props.activePatientId, {
        ...formData.values,
      });
    } else {
      this.props.updateReport(this.props.activePatientId, {
        reportId: this.props.reportId,
        ...formData.values,
      });
    }
    this.props.closePage();
  }

  render() {
    const data = this.props.counselingReports.find(
      report => report._id === this.props.reportId,
    ) || {};
    const { editors, editDates } = data;
    let editHistory = '';
    if (editors) {
      for (let i = 0; i < editors.length; i++) {
        if (i === editors.length - 1) {
          editHistory += `${moment(editDates[i]).format('DD-MM-YYYY, HH:mm')} - ${editors[i]} (created) \n`;
        } else {
          editHistory += `${moment(editDates[i]).format('DD-MM-YYYY, HH:mm')} - ${editors[i]}\n`;
        }
      }
    }

    return (
      <ContentBox title='Counseling Report'>
        <Form getApi={this.setFormApi} autoComplete='off'>
          <table>
            <tbody>
              <tr>
                <td><Label>Counselor Name:</Label></td>
                <td><Text field='counselorName' initialValue={data.counselorName || this.props.activeAccount.name} /></td>
              </tr>
              <tr>
                <td><Label>Contact Details:</Label></td>
                <td><Text field='contactDetails' initialValue={data.contactDetails} /></td>
              </tr>
              <tr>
                <td><Label>Department:</Label></td>
                <td><Text field='department' initialValue={data.department} /></td>
              </tr>
              <tr>
                <td><Label>Case Referred By:</Label></td>
                <td><Text field='caseReferredBy' initialValue={data.caseReferredBy} /></td>
              </tr>
            </tbody>
          </table>
          <div className={styles.notes}>
            <PrimaryText>General Topic for Session</PrimaryText><br />
            <TextArea field='generalTopic' initialValue={data.generalTopic} />
          </div>
          <div className={styles.notes}>
            <PrimaryText>Background</PrimaryText><br />
            <TextArea field='background' initialValue={data.background} />
          </div>
          <div className={styles.notes}>
            <PrimaryText>Session Notes</PrimaryText><br />
            <TextArea field='notes' initialValue={data.notes} />
          </div>
          <div className={styles.notes}>
            <PrimaryText>Findings</PrimaryText><br />
            <TextArea field='findings' initialValue={data.findings} />
          </div>
          <div className={styles.notes}>
            <PrimaryText>Plan of Action</PrimaryText><br />
            <TextArea field='planOfAction' initialValue={data.planOfAction} />
          </div>
          <div className={styles.notes}>
            <PrimaryText>Topics</PrimaryText><br />
            <Multiselect field='topics' initialValue={data.topics} options={topicOptions} />
          </div>
          <table>
            <tbody>
              <tr>
                <td><PrimaryText>Session Date </PrimaryText></td>
                <td><DatetimeText field='date' initialValue={data.date} /></td>
              </tr>
              <tr className={styles.editHistoryRow}>
                <td><strong>Edit History </strong></td>
                <td>{editHistory || '--'}</td>
              </tr>
            </tbody>
          </table>
          <PrimaryButton onClick={this.handleSave}>Save</PrimaryButton>
          <Button onClick={this.props.closePage}>Cancel</Button>
        </Form>
      </ContentBox>
    );
  }
}

const mapStateToProps = state => ({
  activePatientId: state.patient.data.activePatientId,
  counselingReports: state.patient.data.counselingReports,
  activeAccount: state.account.activeAccount,
});

const mapDispatchToProps = dispatch => ({
  addReport:
   (patientId, counselingReport) => dispatch(addReport(patientId, counselingReport)),
  updateReport:
   (patientId, counselingReport) => dispatch(updateReport(patientId, counselingReport)),
});

const EditReportPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditReportComponent);

export default EditReportPage;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/counseling/EditReportPage.jsx